export default "__VITE_ASSET__DnB_sDW4__"